import { Injectable } from '@angular/core';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Observable } from 'rxjs';
import { BlankReceiptRequest } from '../../store/blank-receipts/blank-receipts.interface';
import { util } from '../../util/util';
import { RestService } from './rest.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BlankReceiptRestService {
  constructor(private restService: RestService) {}

  createBlankReceipt(request: BlankReceiptRequest): Observable<object> {
    const params = this.getQueryParams({}, request);
    return this.restService.getBlobData(`/Receipt/createBlankReceipts?${params}`, null, false);
  }

  getBlankReceiptsLocations(customerIdForHeader: string): Observable<Definition[]> {
    return this.restService
      .get<{ shipTos: string[] }>(`/Receipt/getBlankReceiptLocations`, false, false, customerIdForHeader)
      .pipe(map(response => this.blankReceiptsShipTosMapper(response)));
  }

  blankReceiptsShipTosMapper(data: { shipTos: string[] }): Definition[] {
    return Object.keys(data.shipTos).map(key => {
      return { id: key, name: data.shipTos[key] };
    });
  }

  private getQueryParams(params: any, blankReceiptItem: BlankReceiptRequest): string {
    const newParamsObject = {
      ...params,
      Type: blankReceiptItem.type,
      Quantity: blankReceiptItem.quantity,
      Location: blankReceiptItem.shipToId,
    };
    return util.serializeObjectToParams(newParamsObject);
  }
}
